import {
  OrganizationPlanFeatureKey,
  PlanSection,
  PlanType,
} from '@/features/subscriptions/types/subscription-types';
import Bag from '@/shared/assets/bag.png';
import ClientGrowth from '@/shared/assets/client-growth.png';
import Crown from '@/shared/assets/crown.png';
import ExtraDerivativeKpi from '@/shared/assets/extra-derivative.png';
import ExtraSeat from '@/shared/assets/extra-seat.png';
import ExtraSubproject from '@/shared/assets/extra-subproject.png';
import GraphUp from '@/shared/assets/graph-up.png';
import Star from '@/shared/assets/star.png';

export function getFeatureTranslationKey(
  planType: PlanType,
  featureKey: OrganizationPlanFeatureKey,
): string {
  return `plans.${planType}.features.${featureKey}`;
}

export function getNextUpgradePlan(planType: PlanType): PlanType | null {
  switch (planType) {
    case 'essential':
      return 'pro';
    case 'pro':
      return 'enterprise';
    case 'client_core':
      return 'client_growth';
    case 'client_growth':
      return 'client_scale';
  }
  return null;
}

/**
 * Compares two plans and returns:
 * - 1 if plan1 is higher than plan2
 * - -1 if plan1 is lower than plan2
 * - 0 if plan1 is the same as plan2
 * - null if plans are not comparable (different types or addons)
 */
export function comparePlans(
  plan1: PlanType,
  plan2: PlanType,
): 1 | -1 | 0 | null {
  if (plan1 === plan2) return 0;

  const orgPlanOrder: PlanType[] = ['essential', 'pro', 'enterprise'];
  const projectPlanOrder: PlanType[] = [
    'client_core',
    'client_growth',
    'client_scale',
  ];

  const plan1OrgIndex = orgPlanOrder.indexOf(plan1);
  const plan2OrgIndex = orgPlanOrder.indexOf(plan2);
  const plan1ProjectIndex = projectPlanOrder.indexOf(plan1);
  const plan2ProjectIndex = projectPlanOrder.indexOf(plan2);

  // Both are organization plans
  if (plan1OrgIndex !== -1 && plan2OrgIndex !== -1) {
    if (plan1OrgIndex > plan2OrgIndex) return 1;
    if (plan1OrgIndex < plan2OrgIndex) return -1;
    return 0;
  }

  // Both are project plans
  if (plan1ProjectIndex !== -1 && plan2ProjectIndex !== -1) {
    if (plan1ProjectIndex > plan2ProjectIndex) return 1;
    if (plan1ProjectIndex < plan2ProjectIndex) return -1;
    return 0;
  }

  // Plans are not comparable (different types or addons)
  return null;
}

export function getPlanIcon(planType: PlanType): string | null {
  switch (planType) {
    case 'essential':
      return Star;
    case 'pro':
      return Crown;
    case 'enterprise':
      return Bag;
    case 'client_core':
      return Star;
    case 'client_growth':
      return ClientGrowth;
    case 'client_scale':
      return GraphUp;
    case 'extra_seat':
      return ExtraSeat;
    case 'extra_subproject':
      return ExtraSubproject;
    case 'extra_derivative_kpi':
      return ExtraDerivativeKpi;
    case 'contractor_project':
      return Star;
    default:
      return null;
  }
}

export function getIconBgColor(planSection: PlanSection): string {
  switch (planSection) {
    case 'organization':
      return 'bg-blueish-purple';
    case 'project':
      return 'bg-custom-purple';
    case 'addon':
      return 'bg-custom-purple';
  }
}
